import jquery from 'jquery';
import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngTouch from 'angular-touch';
import textAngular from 'textangular';
import 'textangular/dist/textAngular-sanitize';
import './textangularCookie.js';
// import sanitize from 'angular-sanitize';
import ngUiGrid from 'angular-ui-grid';
import toastr from 'angular-toastr';
import bootstrap from 'angular-ui-bootstrap';
import uiRouter from 'angular-ui-router';
import velocity from 'velocity-animate';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import kendo from '@progress/kendo-ui';
import kendostyle from '@progress/kendo-theme-default';
// angular.$$lowercase = (text) => text.toLowerCase();
// angular.lowercase = (text) => text.toLowerCase();
angular
  .module('app', [
    ngAnimate,
    ngTouch,
    textAngular,
    'ui.grid',
    toastr,
    bootstrap,
    uiRouter,
    Common,
    Components,
    'kendo.directives',
  ])
  .config(($locationProvider, toastrConfig, $provide) => {
    'ngInject';
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('');
    $provide.decorator('taOptions', [
      'taRegisterTool',
      '$delegate',
      function(taRegisterTool, taOptions) {
        taOptions.forceTextAngularSanitize = true;
        return taOptions;
      },
    ]);

    angular.extend(toastrConfig, {
      autoDismiss: true,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-bottom-center',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body',
      timeOut: 25000,
      progressBar: true,
    });
  })
  .run(($rootScope, $anchorScroll, $location) => {
    'ngInject';
    $rootScope.config = {
      url: 'https://www.eigenkapitalforum.com/',
      //DEV:
      backendUrl: 'http://localhost:4200/#/',
      backendLoginUrl: 'http://localhost:4200/#/login',
      api: 'http://localhost:3001/api/',
      api2: 'http://localhost:3001/api/',
      //LIVE:
      //api: 'https://api.eigenkapitalforum.com/api/',
      //api2: 'https://api.eigenkapitalforum.com/api/',
      //api: 'https://www.eigenkapitalforum.com/ajax_new/',
      //api: 'https://ekfapi.metacarp-dev.com/api/',
      //api2: 'https://ekfapi.metacarp-dev.com/api/',
      //api: 'http://ekftest.eu-central-1.elasticbeanstalk.com/api/',
      //api2: 'http://ekftest.eu-central-1.elasticbeanstalk.com/api/',
      event_id: false,
      tokenHeader: false,
    };
    if ($location.host().indexOf('metacarp-dev.com') !== -1) {
      $rootScope.config.backendLoginUrl = 'https://backend.metacarp-dev.com/#/';
      $rootScope.config.backendLoginUrl =
        'https://backend.metacarp-dev.com/#/login';
      $rootScope.config.api = 'https://ekfapi.metacarp-dev.com/api/';
      $rootScope.config.api2 = 'https://ekfapi.metacarp-dev.com/api/';
    } else if ($location.host().indexOf('jsben.ch') !== -1) {
      $rootScope.config.backendUrl = 'https://backend.eigenkapitalforum.com/#/';
      $rootScope.config.backendLoginUrl =
        'https://backend.eigenkapitalforum.com/#/login';
      $rootScope.config.api = 'https://test2.jsben.ch/api/';
      $rootScope.config.api2 = 'https://test2.jsben.ch/api/';
    } else if ($location.host().indexOf('eigenkapitalforum.com') !== -1) {
      $rootScope.config.backendUrl = 'https://backend.eigenkapitalforum.com/#/';
      $rootScope.config.backendLoginUrl =
        'https://backend.eigenkapitalforum.com/#/login';
      $rootScope.config.api = 'https://backend.eigenkapitalforum.com/api/';
      $rootScope.config.api2 = 'https://backend.eigenkapitalforum.com/api/';
    } else if ($location.host().indexOf('ekffrontenddev-website.s3-website.eu-central-1.amazonaws.com') !== -1 || $location.host().indexOf('ekf-frontend-staging.metacarp-webhosting.de') !== -1) {
      $rootScope.config.backendUrl = 'https://ekf-api-dev.metacarp-webhosting.de/#/';
      $rootScope.config.backendLoginUrl =
        'https://ekf-api-dev.metacarp-webhosting.de/#/login';
      $rootScope.config.api = 'https://ekf-api-dev.metacarp-webhosting.de/api/';
      $rootScope.config.api2 = 'https://ekf-api-dev.metacarp-webhosting.de/api/';
    }
    $rootScope.$on('$routeChangeSuccess', function(newRoute, oldRoute) {
      if ($location.hash()) $anchorScroll();
    });
  })

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js